// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/panel-right.js';

import { paths } from '../generated/panel-right';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('panel-right', Original, paths);
